import * as React from 'react';
import { useState, useEffect } from 'react';
import { Row, Col, Input, Label, TabContent, TabPane, Nav, NavItem, NavLink, } from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { Afr, getSelectedAfr, updateVersionStateValue, generateLocalStateFromEventProperties, versionStateValue, updateTableFact, existFactsInTable } from '../../redux/AfrSlice';
import { AccountEditorGridNoSubAccountBulk, IAccountEditorGridNoSubaccountsOptions } from '../core/AccountEditorGridNoSubAccountBulk'
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import utilityHelper from '../../utils/utilityHelper';
import enums from '../../utils/enums';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';




const BalanceSheetCore = (props: {
    userRole: string,
    state: any,
    updateState: (newState: any) => void }) => {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);
    const ename = entity ? entity.name : "";
    const ecode = entity ? entity.code : "";
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(true);
    const [bsDocumentation, setBsDocumentation] = useState<string[]>([]);

    const isAdminUser: boolean = useAppSelector(isAdmin);
    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();

    const toggle = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            utilityHelper.saveDeferredChanges(dispatch);
        }
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const currVersion = function () {
        if (currentAfr) {
            if (currentAfr.currentversion) {
                if (currentAfr.currentversion.versionState) {
                    return currentAfr.currentversion.versionState;
                }
            }
        }
        return null;
    }

    function noDataDisabled(noData: boolean) {
        if (hasFacts) {
            if (noData === false) {
                return true;
            }
        }
        return utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified);
    }

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_006_balance-sheet",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    const handleChangeCheckbox = function (event: any) {

        var checkValues = JSON.parse(JSON.stringify(props.state));
        var key: string = event.target.name;
        var value: boolean = event.target.checked
        checkValues[key] = value;


        // here call to dispatcher sending:
        var eventFirstlevel = key.split("_")[0]
        var eventSecondlevel = key.split("_")[1]

        // Update global flag for this event in redux
        dispatch(updateVersionStateValue({ propGroup: eventFirstlevel, propName: eventSecondlevel, boolValue: value, value: null }));

        // set the dirty flag to TRUE
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        props.updateState(checkValues);

    }

   
    useEffect(() => {
        if (!currentAfr) return;
        if (!currentAfr.currentversion) return;
        // get state from redux
        // enable/disable checkbox when there are (no) facts 
        setHasFacts(existFactsInTable(currentAfr, ["uas_006_balance-sheet"]))

        // create a local state from redux
    }, [currentAfr, currVersion(),props.state])
   
    const filteredEditorOptions = function (gname : string, start: string, end: string, exclude: string[]): IAccountEditorGridNoSubaccountsOptions {
        return {
            gridname: gname,
            cellEditHandler: handleCellEdited,
            doneFlag: "na",
            noFlag: "workState_noBalanceSheet",
            fixedRows: false,
            dimensionColumn: null,
            firstFieldId: "FG_001_GeneralFundMember",
            allowedCombinations: null,
            accountRangeFilter: {
                first: start,
                last: end,
                exclude: exclude
            },
            accountGroups: null,
            columnFilter: null
        }
    }

    return (
        <React.Fragment>
            <Page>
                <h2>Balance Sheet for {utilityHelper.getEntityName(entity, currentAfr)} ({utilityHelper.getEntityCode(entity, currentAfr)}), {afrYear}</h2>
                <Row>
                    <Col>
                        <div className="box-events pl-2 pr-3 py-3 my-2">
                            <div>
                                <Label className="ml-4" check>
                                    <Input type="checkbox"
                                        name="workState_noBalanceSheet"
                                        onChange={handleChangeCheckbox}
                                        disabled={noDataDisabled(props.state["workState_noBalanceSheet"])
                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                        checked={props.state["workState_noBalanceSheet"] ? true : false}
                                    />{' '} <b>No Balance Sheet Items</b>
                                </Label>
                                    {isAdminUser && (
                                    <Label className="ml-5" check>
                                        <Input type="checkbox"
                                            name="reviewState_balanceSheetReviewed"
                                            onChange={handleChangeCheckbox}
                                            checked={props.state["reviewState_balanceSheetReviewed"] ? true : false}
                                            disabled={ !utilityHelper.checkStatusList(currentAfr, enums.certifiedRecertified)  }
                                        /><b>Reviewed</b>
                                        </Label>)}
                                </div>
                        </div>
                        <div>
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('1')}
                                        onClick={() => { toggle('1'); }}
                                    >
                                        Instructions
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('2')}
                                        onClick={() => { toggle('2'); }}
                                    >
                                        Assets
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('3')}
                                        onClick={() => { toggle('3'); }}
                                    >
                                        Deferred Outflows
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('4')}
                                        onClick={() => { toggle('4'); }}
                                    >
                                        Liabilities
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('5')}
                                        onClick={() => { toggle('5'); }}
                                    >
                                        Deferred Inflows
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeClass('6')}
                                        onClick={() => { toggle('6'); }}
                                    >
                                        Fund Balances
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <Row>
                                        <Col sm="12">
                                            {bsDocumentation.length === 0
                                                ?
                                                <h5>
                                                    <p>Use the Balance Sheet tabs to enter balance sheet information by account code and fund group.</p>
                                                    <p>Use the + symbol to add account codes and the - symbol next to the account code to delete the account code. To update an existing line of revenue data, simply click within the table below the listed fund groups and to the right of the account codes to edit the account code line items. Fields will only allow whole numbers (no decimals).</p>
                                                </h5>
                                                :
                                                <h5>
                                                    {bsDocumentation.map((option: string, idx) => (
                                                        <div dangerouslySetInnerHTML={{ __html: "<p>" + option + "</p>" }} ></div>
                                                    ))}
                                                </h5>
                                            }
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "2") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("assets", "101.000", "181.000", [])}
                                                    setHasData={setHasFacts}
                                                /> )
                                            }
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="3">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "3") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("deferredoutflows", "190.000", "190.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="4">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "4") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("liabilities","201.000", "273.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="5">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "5") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("deferredinflows", "290.000", "290.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="6">
                                    <Row>
                                        <Col sm="12">
                                            {(activeTab === "6") && (
                                                <AccountEditorGridNoSubAccountBulk
                                                    tableName="uas_006_balance-sheet"
                                                    gridData={[]}
                                                    gridColumns={[]}
                                                    gridOptions={[]}
                                                    options={filteredEditorOptions("fundabalances", "274.000", "284.000", [])}
                                                    setHasData={setHasFacts}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default BalanceSheetCore;